import combineComponents from './combineComponents';

export default combineComponents;
